import React, { useState, useEffect } from 'react';
import Dropdown from '../../shared/components/Dropdown/Dropdown';
import MovistaLogo from '../../assets/movista-wordmark.png';
import { Logo } from '../Logo/Logo';
import { USER_LOCALE } from '../../shared/constants/LocalStorageKeys/LocalStorageKeys';
import './LoginPageHeader.css';

const LANGUAGE_EN = 'en';
const LANGUAGE_FR = 'fr';
const LANGUAGE_TEXT_DICT = {
    [LANGUAGE_EN]: 'English',
    [LANGUAGE_FR]: 'French',
};
export const LoginPageHeader = () => {
    const [selection, changeSelection] = useState('');
    useEffect(() => {
        const currentLanguage = localStorage.getItem(USER_LOCALE) || LANGUAGE_EN;
        changeSelection(LANGUAGE_TEXT_DICT[currentLanguage]);
    }, []);

    const dropdownOptions = [LANGUAGE_EN, LANGUAGE_FR].map((language) => ({
        key: language,
        text: LANGUAGE_TEXT_DICT[language],
        onClick: () => {
            changeSelection(LANGUAGE_TEXT_DICT[language]);
            document.cookie = `LOCALE=${language}`;
            localStorage.setItem(USER_LOCALE, language);
            window.location.reload();
        },
    }));

    return (
        <div className="loginPageHeaderWrapper">
            <Logo className="movistaLogo" url={MovistaLogo} alt="Movista" />
            <Dropdown
                id="languageDropdown"
                testId="languageDropdown"
                className="languageDropdown"
                dropdownType="dropdownAction"
                dropdownButtonStyle="secondary"
                iconType="chevron"
                text={selection}
                options={dropdownOptions}
            />
        </div>
    );
};

export default LoginPageHeader;
